$(function() {
    $('#dismiss-banner').on('click', function(e){
        const banner = document.getElementById("emergency-banner");
        $(banner).hide();
    });
});